import type { RouteObject } from 'react-router';

import { BASE, ID_PARAMS } from 'common/src/routes/BaseRoutes';

import AlertsPage from 'portal/src/pages/alerts/AlertsPage';

const AlertsRoute: RouteObject = {
  path: `${BASE.ALERTS}/${ID_PARAMS.ANY}?`,
  element: <AlertsPage />,
};

export default AlertsRoute;
